module.exports = __webpack_public_path__ + "img/007李云龙.1d845091.png";